// Lightweight subsequence fuzzy matcher used by the command palette and the
// watchlist filter. Returns a relevance score (higher is better) or null when
// the query characters do not appear in order within the text.
export function fuzzyMatch(query: string, text: string): number | null {
  const q = query.toLowerCase();
  const t = text.toLowerCase();
  if (q.length === 0) {
    return 0;
  }

  let qi = 0;
  let score = 0;
  let streak = 0;
  let prevMatch = -2;

  for (let ti = 0; ti < t.length && qi < q.length; ti += 1) {
    if (t[ti] !== q[qi]) {
      continue;
    }

    let bonus = 1;
    if (ti === 0) {
      bonus += 5; // matches the very start of the string
    } else if (/[\s\-_./]/.test(t[ti - 1])) {
      bonus += 3; // matches the start of a word
    }
    if (prevMatch === ti - 1) {
      streak += 1;
      bonus += streak * 2; // reward contiguous runs
    } else {
      streak = 0;
    }

    score += bonus;
    prevMatch = ti;
    qi += 1;
  }

  if (qi < q.length) {
    return null; // not every query character was consumed
  }

  // Nudge shorter texts and earlier first matches ahead on ties.
  return score - text.length * 0.04;
}
